import {
  Component, OnInit, AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Inject,
} from '@angular/core';
import { AuthenticationService } from "../services/authentication.service";
import Swal from 'sweetalert2'
import { StripeToken, StripeSource } from "stripe-angular";
import { NgForm } from "@angular/forms";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
declare var stripe: any;

@Component({
  selector: 'app-my-banner-plans',
  templateUrl: './my-banner-plans.component.html',
  styleUrls: ['./my-banner-plans.component.css']
})

export class MyBannerPlansComponent implements OnInit {

  @ViewChild("cardInfo") cardInfo: ElementRef;

  allPlans: Array<any> = [];
  bannerSizePlans: Array<any> = [];
  loading = false;
  personalDetails!: FormGroup;
  addressDetails!: FormGroup;
  educationalDetails!: FormGroup;
  personal_step = false;
  address_step = false;
  education_step = false;
  step = 1;
  selectBannerPlan: string;

  card: any;
  public invalidError: any;
  // cardHandler = this.onChange.bind(this);
  error: string;
  defaultCard: string;
  showSpinner: Boolean = true;
  enablePromo: Boolean = false;
  isCouponValid: Boolean = false;
  copuonAppliedMsg: string = "";
  discount: any = 0;
  coupon: string = "";
  couponApplied: Boolean = false;
  checkBannerSize:any
  captionType:any;
  public cards = [];
  amount: any = 0;
  loadingMsg: string = "Loading ...";
  public user: any;
  public plan: any;
  public form: FormGroup;
  public range: any;
  public cardId: any;
  subscriptionId: any = '';
  spinnerType = SPINNER.circle;
  public isCouponApplied: any;
  isBannerPlan = false;
  isBannerSizePlan = false;
  cardReady = false;
  userBasicBannerPlan: any;
  bannerPlanType: any;
  bannerSizePlanType: any;
  myBannerPlan: any;
  myBannerPlans: any;
  subscription:any;
  total = 0;
  bannerPrice = 0;
  bannerSizePrice = 0;
  selectedSubscriptionPlan: any;
  isDiscount:any;
  planName:any;
  planList:any
  constructor(
    public fb: FormBuilder,
    private ngxService: NgxUiLoaderService,
    public authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router

  ) {
    this.route.queryParams.subscribe((params) => {
      this.subscriptionId = params.id;
    })
  }

  ngOnInit(): void {
    this.subscriptionPlans();
    this.getProfile();
  }

  next(planType: string) {
    localStorage.removeItem('planDetail')
    if(this.subscription && this.subscription?.length > 0 && this.subscription[0]?.amount == 0 || !this.subscription?.length) {
      return Swal.fire(
        "Oops...",
        "To begin utilizing our banner plan feature and creating banner advertisements, it is necessary to upgrade your current plan to a paid profile base plan.",
        "error"
      )
    } 
    if(this.myBannerPlans && this.myBannerPlans.length) {
      return Swal.fire(
        "Oops...",
        "You are already subscribed to the base plan. Please cancel your subscription to proceed.",
        "error"
      )
    }
    if (!this.isBannerPlan) {
      return Swal.fire({
        title: "Choose Banner Plan",
        icon: 'error'
      });
    }

    if (!this.isBannerSizePlan) {
      return Swal.fire({
        title: "Choose Banner Size Plan",
        icon: 'error'
      });
    }
    const plan = this.planList.filter((val=>val.caption == this.captionType && val.price == this.total));
    localStorage.setItem('planDetail', JSON.stringify(plan[0]))
      this.router.navigate(['/add-banner-ads'], { queryParams: { bannerPlanId: plan[0]._id, isDiscount:this.isDiscount} });
  }


reNewPlan(id:any){
  console.log("value of plan is",id)
  this.selectBannerPlan=id
  //  this.router.navigate(['/base-payment'], { queryParams: { bannerPlanId: this.selectBannerPlan, bannerSizeId:this.selectedSubscriptionPlan, isBannerPlan:isBannerPlan, isBannerSizePlan:isBannerSizePlan } });
  this.router.navigate(['/base-payment'], { queryParams: { bannerPlanId: id } });


}
  
  subscriptionPlans(): void {
    this.spinner.show();
    this.authenticationService.getBannerPlans().subscribe(
      (response: any) => {
        console.log(response?.data, "resss")
        this.planList = response?.data;
        const uniqueBannerPlans = this.getUniqueObjects(response?.data, 'visibiltyPrice');
        const uniqueBannerSize = this.getUniqueObjects(response?.data, 'bannerSizePrice');
        this.bannerSizePlans = uniqueBannerSize
        this.allPlans = uniqueBannerPlans;
        this.allPlans = this.allPlans.filter(val => val.caption !== "Business Quarterly");
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        if (error.error.message == "Unauthorized") {
          this.authenticationService.logout();
        }
      }
    );
  }
  getUniqueObjects(arr, prop) {
    return arr.filter((obj, index, self) =>
      index === self.findIndex((o) => o[prop] === obj[prop])
    );
  }
  convertSubscripitonType(days) {
    if (days === 365) {
      return "Yearly"
    } else if (days === 30) {
      return "Monthly"
    } else if (days === 90) {
      return "Quarterly"
    }
    else if (days === 180) {
      return "Half Yearly"
    }
    return "Days"
  }

  changeBannerPlans(value: any, action: any) {
    this.selectedSubscriptionPlan = value?._id;
    if (action === 'banner') {
      this.captionType = value.caption;
      this.bannerPrice = value?.visibiltyPrice;
      this.isBannerPlan = true;
     
    } else if (action === 'size') {
      this.bannerSizePrice =  value?.bannerSizePrice;
      this.isBannerSizePlan = true;
    }
    this.total = this.bannerPrice+this.bannerSizePrice;
  }

  getProfile() {
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        if (response && response?.data) {
          console.log(response?.data, 'response?.data')
          this.bannerPlanType = response?.data?.bannerPlanType;
         
          this.myBannerPlans = this.bannerPlanType;
          this.subscription = response?.data.subscriptions
          let checkBannerSize = this.allPlans.filter(val => val.price == this.bannerPlanType[0]?.amount && val.caption == this.bannerPlanType[0].caption);
          this.checkBannerSize = checkBannerSize[0]?.bannerSize;
          this.getPlanById(response?.data?.subscriptionPlanType)
          this.total = this.bannerPrice+this.bannerSizePrice;
        }
      },
      (error) => {
        console.error(error)
      }
    )
  }
  getPlanById(id:any) {
    this.authenticationService.getPlanById(id).subscribe(
      (response: any) => {
        if (response && response?.data) {
          this.planName = response?.data?.caption
          if(response.data.caption == "Founder" || response.data.caption ==  "Community Builder"){
            this.isDiscount = 'true';
          }
          console.log(response?.data, '********', this.planName, response?.data?.caption)
        }
      },
      (error) => {
        console.error(error)
      }
    )

  }
  isSubscribedToBannerSizePlan(): boolean {
    return this.myBannerPlans?.some(plan => plan.type === 'bannerSize' && plan.isActive && plan.isPaid);
  }

  isSubscribedToBannerPlan(): boolean {
    return this.myBannerPlans?.some(plan => plan.type === 'basic' && plan.isActive && plan.isPaid);
  }
  delete() {
      this.authenticationService.deleteBanner().subscribe(
        (response: any) => {
        },
        (error) => {
          if (error) {
            Swal.fire('Error', error.error.message, 'error');
          }
        }
      );
    
  }
  cancelSubscription(id: String) {
    Swal.fire({
      title: 'Are you sure you want to Cancel your Subscription?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.authenticationService.cancelBannerSubscription(id).subscribe(
          (response: any) => {
            console.log(response, 'response1234')
            if (response?.code === 200) {
              this.delete()
              if(this.selectBannerPlan == id) this.selectBannerPlan = ''
              if(this.selectedSubscriptionPlan == id) this.selectedSubscriptionPlan = ''
              Swal.fire({
                title: "Subscription Cancelled Successfully",
                icon: 'success'
              })
              setTimeout(()=>{                           // <<<---using ()=> syntax
                window.location.reload();
                this.getProfile();
            }, 3000);
              
            }
            console.log("ressssss", response);
          },
          (error) => {
            console.error(error)
          }
        )
      }
    })
  }
}
